import React from 'react';
import './Awards.css';

export default function AwardsCard({
  year,
  title,
  institution,
  position,
  description,
  link
}) {
  return (
    <div className="award-card">

      {/* Year badge */}
      <div className="award-year">{year}</div>

      {/* Main content */}
      <div className="award-content">
        <h3 className="award-title">{title}</h3>

        <p className="award-institution">{institution}</p>

        {position && (
          <p className="award-position">{position}</p>
        )}

        {description && (
          <p className="award-description">{description}</p>
        )}

        {link && (
          <a
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            className="award-link"
          >
            View Challenge / Details →
          </a>
        )}
      </div>

    </div>
  );
}
